import { isValid, parse, startOfDay } from 'date-fns'
import { has, map } from 'lodash-es'

import { EMPTY_LIST, EMPTY_STRING } from '../../../constants/common'
import { DATE_API_DATA_FORMAT } from '../../../constants/date'
import {
  ACTIVE_FILTER_NAME,
  AUTOMATIONS_FILTER_NAME,
  CHATS_FILTER_NAME,
  DOCUMENTS_FILTER_NAME,
  EMAILS_FILTER_NAME,
  FLOAT_LIST_TYPE,
  STATUS_FILTER_NAME,
  TASK_STATUS_FILTER_NAME,
  VISIBLE_TO_TENANT_FILTER_NAME,
} from '../../../constants/filter'
import {
  createNowDateInUkTimezone,
  transposeToUkTimezoneDate,
} from '../../../utils/date'
import {
  getDateEndParam,
  getDateStartParam,
  getFloatLabel,
} from '../../../utils/filter'
import { getFilterOptionLabel } from '../Filter.utils'

export function getOptionValue(option) {
  return option.value
}

export function getOptionLabel({ entity, listType, name, option, t }) {
  if (listType === FLOAT_LIST_TYPE) {
    return getFloatLabel(option)
  }

  if (listType) {
    return option.label
  }

  return getFilterOptionLabel({ entity, name, option, t }) ?? option.label
}

export function getFilterValues(filterName, filterOptions) {
  if (has(filterOptions, filterName)) {
    return map(filterOptions[filterName], 'value')
  }

  return EMPTY_LIST
}

export function getFilterSelectTypeValues(filterName, filterOptions) {
  if (has(filterOptions, filterName)) {
    return [filterOptions[filterName].value]
  }

  return EMPTY_LIST
}

export function getMultiSelectButtonType(name) {
  switch (name) {
    case ACTIVE_FILTER_NAME:
    case AUTOMATIONS_FILTER_NAME:
    case CHATS_FILTER_NAME:
    case DOCUMENTS_FILTER_NAME:
    case EMAILS_FILTER_NAME:
    case STATUS_FILTER_NAME:
    case TASK_STATUS_FILTER_NAME:
    case VISIBLE_TO_TENANT_FILTER_NAME:
      return 'select'

    default:
      return undefined
  }
}

export function getDateRangeFilterParams(name, filterOptions) {
  const startDateParam = getDateStartParam(name)
  const endDateParam = getDateEndParam(name)

  const initialStart = filterOptions?.[startDateParam]?.value || null
  const initialEnd = filterOptions?.[endDateParam]?.value || null

  return {
    endDateParam,
    filtersCount: initialStart || initialEnd ? 1 : 0,
    initialEnd,
    initialStart,
    startDateParam,
  }
}

export function getNumberRangeFilterParams(name, filterOptions) {
  const startParam = getDateStartParam(name)
  const endParam = getDateEndParam(name)

  const initialStart = filterOptions?.[startParam] ?? EMPTY_STRING
  const initialEnd = filterOptions?.[endParam] ?? EMPTY_STRING

  return {
    endParam,
    filtersCount: initialStart || initialEnd ? 1 : 0,
    initialEnd,
    initialStart,
    startParam,
  }
}

export function getMultiSelectFilterCount(name, filterOptions, filterValues) {
  return name.includes('_range') && filterValues.length === 0
    ? getDateRangeFilterParams(name, filterOptions).filtersCount
    : filterValues.length
}

export function parseApiDateToUkDay(value, timezone) {
  if (!value) {
    return null
  }

  const base = createNowDateInUkTimezone(timezone)
  const parsed = parse(value, DATE_API_DATA_FORMAT, base)

  if (!isValid(parsed)) {
    return null
  }

  return transposeToUkTimezoneDate(startOfDay(parsed), timezone)
}

// `IntegerInput` emits a number, and the toggle-shaped handler omits a falsy
// value — so a legitimate bound of 0 would clear the filter. Params are strings
// anyway, and "0" survives the check.
export function toNumberRangeBound(value) {
  return value === null || value === undefined ? value : String(value)
}
